import { defineType } from "sanity";
import { airNonAirFilter, locationFilter } from "../base";
import { multilingualBlockContentPreview } from "../base/multilingualArrayBlockContent";

export default defineType({
  name: "emotionalSlidePromoContent",
  type: "object",
  title: "Slide promo content",
  fields: [
    {
      name: "promo",
      title: "Promo",
      type: "reference",
      to: [
        {
          type: "exclusiveOfferPerPromo"
        }
      ],
      validation: (Rule) => Rule.required()
    },
    {
      name: "image",
      type: "imageWithAlt",
      options: {
        hotspot: true,
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "blockTitle",
      title: "Title",
      type: "multilingualArrayBlockContent"
    },
    {
      name: "content",
      title: "Content",
      type: "multilingualArrayBlockContent"
    },
    {
      type: "ctaButtons",
      name: "ctaButtons",
      title: "CTA Buttons",
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "locationFilters",
      title: "Location Filters",
      type: "array",
      of: [
        {
          type: locationFilter.name
        },
        {
          type: airNonAirFilter.name
        }
      ]
    },
    {
      name: "customKey",
      title: "Custom Key",
      description: "Used to identify the slide in the code",
      type: "string"
    },
    {
      name: "showCruiseCount",
      title: "Show Cruise Count",
      type: "boolean",
      description:
        "Show the number of cruises available with the selected promo"
    },
    {
      name: "showCountdown",
      title: "Show Countdown",
      type: "boolean",
      description: "Show countdown timer"
    },
    {
      name: "countdownLabel",
      title: "Countdown label",
      type: "multilingualArrayString",
      hidden: ({ parent }) => !parent?.showCountdown
    }
  ],
  preview: {
    select: {
      imageUrl: "image",
      blockTitle: "blockTitle"
    },
    prepare({ blockTitle, imageUrl }) {
      return {
        //@ts-ignore
        title: multilingualBlockContentPreview(100)(blockTitle),
        media: imageUrl
      };
    }
  }
});
